exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#notifications .redux-toastr .toastr {\n  border-radius: 0; }\n", ""]);

